import React from "react";
import TextField from "@mui/material/TextField";
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

export default function Tags(props) {

  let dropDownOptions,placeholder;
  let dropdownClassName;

  if(props.value.length===0){
    dropDownOptions=props.fileColumns;
    placeholder='Start your rule by selecting a column name';
    dropdownClassName='rule-columns-listing';
  }

  else if (props.value.length%2===0){
    dropDownOptions=props.fileColumns;
    placeholder='Select a column name or enter a value'
    dropdownClassName='rule-columns-listing';
  }

  else{
    dropDownOptions=props.operation;
    placeholder='Select a math operation'
    dropdownClassName='';
  }


  const handleKeyDown = event => {

    if (event.key === 'Enter' && event.shiftKey && props.value.length%2===0 ) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target.value.length > 0) {
        if(event.target.value.indexOf(' ')>=0){
          var customVal=[...props.value,{label:event.target.value.replace(/ /g,"space"),value:event.target.value,origin:'custom'}];
        }else{
          customVal=[...props.value,{label:event.target.value,value:event.target.value,origin:'custom'}];
        }

        props.onSelectValue(customVal);
      }
    }

    // switch (event.key) {
    //   case "Enter":
    //   case " ": {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     if (event.target.value.length > 0) {
    //       var customVal=[...props.value,{label:event.target.value,origin:'custom'}];
    //       props.onSelectValue(customVal);
    //     }
    //     break;
    //   }
    //   default:
    // }


  };




  return (
    <div>
    <ComponentErrorBoundary value="rule autocomplete">
      <Autocomplete
        multiple
        disableCloseOnSelect
        autoHighlight
        classes={{ listbox: dropdownClassName }}
        options={dropDownOptions}
        getOptionLabel={option => option.label || option}
        groupBy={option => option.origin}
        value={props.value}
        isOptionEqualToValue={(value)=>{}}
        onChange={(event, newValue) => {props.onSelectValue(newValue);}}
        onBlur={()=>{props.validateTheRule();}}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip label={option.label} classes={{ root: option.origin }} {...getTagProps({ index })} />
          ))
        }
        renderInput={params => {
          params.inputProps.onKeyDown = handleKeyDown;
          return (
            <TextField
              {...params}
              variant="standard"
              label={props.label}
              placeholder={placeholder}
              margin="normal"
              error={props.ruleContentErrorStatus}
              helperText={props.ruleContentErrorText}
              fullWidth
            />
          );
        }}
      />
      </ComponentErrorBoundary>
    </div>
  );
}
